import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { Consent } from '../types';

type ConsentDetailsProps = {
    consent: Consent;
};

export const ConsentDetails = ({ consent }: ConsentDetailsProps) => {
    const descriptionText =
        consent.app_name === consent.tpp_name ? (
            <FormattedMessage
                id="_.credit_card.preferences.consent_accordion.consent_description.simple"
                defaultMessage="{appName} has access to the following information:"
                values={{ appName: consent.app_name }}
            />
        ) : (
            <FormattedMessage
                id="_.credit_card.preferences.consent_accordion.consent_description.full"
                defaultMessage="{tppName} ({appName}) has access to the following information:"
                values={{
                    appName: consent.app_name,
                    tppName: consent.tpp_name
                }}
            />
        );

    return (
        <>
            <Text weight="reg">{descriptionText}</Text>
            <ul className="list-inside list-disc font-bold">
                {consent.permissions.map((permission) => (
                    <li className="capitalize" key={permission}>
                        {permission}
                    </li>
                ))}
            </ul>
        </>
    );
};
